<style scoped>
.mb8 {
    margin-bottom: 8px;
}

.iframe-sty {
    width: 100%;
    border: none;
    height: 600px;

}

.flow {
    background: #fff;
    padding-left: 20px;
    margin-top: 4px;
}

.pdt100 {
    padding-bottom: 100px !important;
}

.header {
    background: #fff;
    margin: 4px 0;
    font-size: 16px;
    text-align: center;
    line-height: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    padding: 0 16px;

}

.header .back {
    background: #FFFFFF;
    border: 1px solid rgba(217, 217, 217, 1);
    border-radius: 2px;
    width: 60px;
    height: 28px;
    line-height: 28px;
    font-size: 12px;
    cursor: pointer;
}

.import-title {
    text-align: left;
    background: #fff;
    padding: 10px 16px;
    font-size: 16px;
    position: relative;
}

.import-title.second {
    margin-top: 4px;
}

.header .title {
    text-align: center;
    flex: 1;
}

.customer-information {
    background: #fff;
    padding-bottom: 15px;
}

.customer-information .sub-title {
    text-align: left;
    font-size: 14px;
    padding: 10px 16px;
    position: relative;
}

.sub-operate-add {
    color: #4FA1A4;
    margin-left: 14px;
    cursor: pointer;
}

.customer-information .cols {
    background: #fff;
    display: flex;
    padding: 4px 16px;
    padding-left: 20px;
}

.customer-information .col-itms {
    display: flex;
    align-items: center;
    margin-left: 20px;
}

.customer-information .col-itms .title {
    width: 120px;
    text-align: right;
    margin-right: 16px;
}

.customer-information .col-itms.second {
    margin-left: 170px;
}

.customer-information .col-itms .title span {
    color: red;
}

.import-new-wrap {
    padding-bottom: 15px;
}

.import-new-wrap .import-step-tip {
    text-align: left;
    padding-left: 170px;

}

.import-new-wrap .col-itms {
    align-items: baseline;
}

.operte-btns {
    background: #fff;
    margin-top: 4px;
    display: flex;
    justify-content: center;
    padding: 25px 0;

}

.operte-btns .btn {
    padding: 5px 18px;
    border: 1px solid rgba(217, 217, 217, 1);
    border-radius: 2px;
    cursor: pointer;
    margin-right: 10px;

}

.operte-btns .btn.save {

    border: 1px solid rgba(79, 161, 164, 1);
    color: rgba(79, 161, 164, 1);
    cursor: pointer;
}

.operte-btns .btn.submit {
    border: 1px solid rgba(79, 161, 164, 1);
    background: rgba(79, 161, 164, 1);
    color: #fff;
    cursor: pointer;

}

.content-main-box {
    height: auto !important;
}

.search-wrap {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}

.search-wrap .input-search {
    width: 200px;
}

.sub-operate-add {
    color: #4fa1a4;
    margin-left: 14px;
    cursor: pointer;
}

.sub-operate-add2 {
    color: #4fa1a4;
    font-size: 14px;
    margin-left: 14px;
    cursor: pointer;
    position: absolute;
    right: 35px;
    top: 10px;
    text-align: center;
}

.sub-operate-del {
    font-size: 14px;
    color: #4fa1a4;
    cursor: pointer;
    text-align: center;
    margin: 0 20px;
}
</style>

<template>
    <div class="project-edit" v-loading.fullscreen.lock="fullscreenLoading">
        <div class="header">
            <div class="back" @click="$router.go(-1)">返回</div>
            <div class="title">停线申请</div>
        </div>
        <div class="import-title">基础信息</div>
        <div class="customer-information">
            <div class="cols">
                <div class="col-itms">
                    <div class="title"><span>*</span>停线原因</div>
                    <el-select v-model="form.lineStopRuleGuid" placeholder="请选择" filterable class="w300">
                        <el-option v-for="item in reasonList" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </div>
                <div class="col-itms second">
                    <div class="title"><span>*</span>是否为首次申请</div>
                    <el-select v-model="form.isFirstApply" placeholder="请选择" filterable class="w300">
                        <el-option v-for="item in isFirstApplyList" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </div>
            </div>
            <div class="cols">
                <div class="col-itms">
                    <div class="title"><span>*</span>具体原因</div>
                    <el-input rows="1" class="w300" type="textarea" maxlength="200" placeholder="请填写"
                        v-model="form.stopReasonDefinite"></el-input>
                </div>
                <div class="col-itms second">
                    <div class="title"><span style="color:#fff;">*</span>活动参与人员</div>
                    <el-select v-model="form.lineStopApplyStaffList" placeholder="请选择" multiple filterable class="w300">
                        <el-option v-for="item in staffList" :key="item.guid" :label="item.staffName"
                            :value="item.guid"></el-option>
                    </el-select>
                </div>
            </div>


            <div class="cols">
                <div class="col-itms">
                    <div class="title"><span style="color:#fff;">*</span>备注</div>
                    <el-input rows="4" class="w300" type="textarea" maxlength="200" placeholder="请填写"
                        v-model="form.memo"></el-input>
                </div>
            </div>
        </div>
        <div class="import-title second">
            <span class="cost-title-list-txt">停线明细{{ form.lineStopApplyDetails && form.lineStopApplyDetails.length }}</span>
            <div class="sub-operate-add2" @click="addListItem">新增</div>
        </div>
        <div class="customer-information">

            <section v-for="(item, index) in form.lineStopApplyDetails" :key="index">
                <div class="sub-title">
                    停线时间{{ index + 1 }}
                    <div class="sub-operate-add2" @click="delListItem(index)">删除</div>
                </div>
                <div class="col-itms mb8">
                    <div class="title"><span>*</span>停线时间</div>
                    <el-date-picker :picker-options="limitOptions" class="w300" type="date" value-format="yyyy-MM-dd"
                        @change="item.amendTime = ''" placeholder="选择停线时间" v-model="item.stopTime"></el-date-picker>
                </div>
                <div class="col-itms">
                    <div class="title"><span>*</span>回补时间</div>
                    <el-date-picker :picker-options="limitOptions" :disabled="!item.stopTime" class="w300" type="date"
                        @change="checkAmendTime(index)" value-format="yyyy-MM-dd" placeholder="选择回补时间"
                        v-model="item.amendTime"></el-date-picker>
                </div>
            </section>
        </div>
        <div class="import-title second">附件上传</div>
        <div class="customer-information">
            <div class="import-new-wrap">
                <div class="cols">
                    <div class="col-itms" style="align-items: flex-start;">
                        <div class="title"><span style="color:#fff;">*</span>附件上传</div>
                        <el-upload class="upload-demo t-left" action="#" ref="createProject" :file-list="form.attaches"
                            accept=".jpg,.png,jpeg" :auto-upload="true" list-type="picture-card"
                            :http-request="changeMainFile">

                            <div slot="file" slot-scope="{file}">
                                <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                                <span class="el-upload-list__item-actions">
                                    <span disabled class="el-upload-list__item-preview"
                                        @click="handlePictureCardPreview(file)">
                                        <i class="el-icon-zoom-in"></i>
                                    </span>

                                    <span disabled @click="handleMainRemove(file)" class="el-upload-list__item-delete">
                                        <i class="el-icon-delete"></i>
                                    </span>
                                </span>
                            </div>
                            <i class="el-icon-plus"></i>
                        </el-upload>
                    </div>
                </div>
                <div class="import-step-tip">当前支持jpg、png、jpeg格式文件，单个文件不得大于5M</div>
            </div>
        </div>
        <div class="operte-btns">
            <div class="btn cancel" @click="$router.go(-1)">取消</div>

            <div class="btn submit" @click="saveReq">确定</div>
        </div>
        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
    </div>
</template>
<script>
export default {
    components: {
    },
    data() {
        return {
            dialogVisible: false,
            dialogImageUrl: '',
            fullscreenLoading: false,
            reasonList: [],
            staffList: [],
            isFirstApplyList: [{ label: '是', value: 'Y' }, { label: '否', value: 'N' }],
            guid: '',
            startDate: null,
            endDate: null,
            form: {
                "guid": "",
                "tenantGuid": "",
                "lineStopRuleGuid": "", // 停线原因
                "stopReasonDefinite": "", // 具体原因
                "isFirstApply": "", // 是否为本考核月非公司统一活动的首次申请
                "memo": "", // 备注
                "lineStopApplyStaffList": [], // 公司统一活动参与人员
                "lineStopApplyDetails": [], // 停线明细
                "attaches": []
            },
            limitOptions: {

            }

        }
    },
    computed: {

    },
    created() {
        this.getDetail();

    },
    methods: {
        getDetail() {
            let self = this;
            if (!this.$route.query.guid) return;
            self.api.get(`/${serverConfig.msSalesPerformService}/line-stop-apply/detail/${this.$route.query.guid}`).then((
                res) => {
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                    this.form = res.data.data;
                    this.getReasonList(this.form.tenantGuid)
                    this.getStaffList(this.form.tenantGuid, this.form.applyStaffGuid)
                    this.getTimeLimit(this.form.tenantGuid);

                    //处理附件
                    if (!this.form.attaches) {
                        this.form.attaches = [];
                        return;
                    }
                    let attaches = [];
                    this.form.attaches.forEach(itme => {
                        attaches.push({
                            name: itme.fileName,
                            url: itme.path
                        })
                    })

                    this.form.attaches = attaches;
                } else {
                    self.$message.error(res.data.msg);
                }
            });
        },
        getStaffList(tenantGuid, applyStaffGuid) {
            let req = {
                tenantGuid: tenantGuid,
                isBizUnit: 'Y',
                pageIndex: 1,
                pageSize: -1,
                staffGuid: applyStaffGuid
            }
            this.api.postJson(`/${serverConfig.msPersonnelService}/staff/data/get-no-self-new`, req).then((res) => {
                this.staffList = res.data.data.records;
                //处理人
                if (this.form.lineStopApplyStaffList) {
                    let lineStopApplyStaffList = [];
                    this.form.lineStopApplyStaffList.forEach(item => {
                        lineStopApplyStaffList.push(item.staffGuid);
                    })
                    this.form.lineStopApplyStaffList = lineStopApplyStaffList;
                    console.log(this.form.lineStopApplyStaffList)
                }

            })
        },
        getReasonList(tenantGuid) {
            let req = {
                tenantGuid: tenantGuid,
                pageIndex: 1,
                pageSize: -1
            }
            this.api.postJson(`/${serverConfig.msConfigureService}/line-stop-rule/list`, req).then(resp => {
                let data = resp.data.data.records;
                this.reasonList = [];
                if (!data) return;
                data.forEach(item => {
                    this.reasonList.push({
                        label: item.stopReason,
                        value: item.guid
                    })
                })
            })
        },
        chooseTime(type, index, date) {
            let tenantGuid = localStorage.tenantGuid;
            if (type == 'stopTime') {
                //清空回补时间
                this.form.lineStopApplyDetails[index].amendTime = '';
            }
            console.log(this.form.lineStopApplyDetails[index])
            let time = this.form.lineStopApplyDetails[index] && this.form.lineStopApplyDetails[index].stopTime || date
            this.Ajax.get(`/${serverConfig.msConfigureService}/sysparameter/data/get-account-month-full-area?tenantGuid=${tenantGuid}&date=${time}`).then(res => {
                if (res.msg == "success") {
                    let timeArr = res.data && res.data.split(',');
                    this.form.lineStopApplyDetails[index].amendTimeStartDate = timeArr[0];
                    this.form.lineStopApplyDetails[index].amendTimeEndDate = timeArr[1];
                } else {
                    this.Toast(resp.msg)
                }
            });
        },
        getTimeLimit(tenantGuid) {
            let that = this;
            let today = this.$moment(new Date()).format('YYYY-MM-DD');
            that.api.postJson(`/${serverConfig.msConfigureService}/sysparameter/data/get-account-month-full-area-by-direction`, {
                tenantGuid: tenantGuid,
                date: today,
                amount: 1
            }).then((resp) => {
                if (resp.data.msg == "success") {
                    // console.log(resp.data)
                    this.timeLimit = resp.data.data && resp.data.data.length ? resp.data.data[0].parameterValue : "";
                    if (resp.data.data) {
                        this.startDate = resp.data.data.split(',')[0];
                        this.endDate = resp.data.data.split(',')[1];
                        if (!this.form.lineStopApplyDetails) {
                            this.form.lineStopApplyDetails = [{
                                "stopTime": '',
                                "amendTime": '',
                            }]
                            this.limitOptions = {
                                disabledDate(time) {
                                    return (time.getTime() < new Date(that.startDate).getTime()) || (time.getTime() > new Date(that.endDate).getTime())
                                }
                            }
                        }
                    }
                }
            });
        },
        addListItem() {
            this.form.lineStopApplyDetails.push({
                "stopTime": '',
                "amendTime": '',
            })
        },
        checkAmendTime(index) {
            let query = JSON.parse(JSON.stringify(this.form));
            let lineStopRuleGuid = query.lineStopRuleGuid;
            let tenantGuid = query.tenantGuid;
            let lineStopApplyDetails = query.lineStopApplyDetails;
            let amendTime = query.lineStopApplyDetails[index].amendTime;
            let inputTime;

            lineStopApplyDetails.forEach(item => {
                if (item.inputTime) {
                    inputTime = item.inputTime;
                }
                delete item.amendTimeEndDate
                delete item.amendTimeStartDate
                delete item.stopTimeStartDate
                delete item.stopTimeEndDate
                delete item.guid

            })
            if (!lineStopRuleGuid || !amendTime||!inputTime) return;
            let req = {
                lineStopRuleGuid,
                tenantGuid,
                lineStopApplyDetails,
                isApprove: this.dialogImageUrl ? 'Y' : 'N',
                staffGuid: this.form.applyStaffGuid
            }
            this.api.postJson(`/${serverConfig.msSalesPerformService}/line-stop-apply/amend-time-check`, req).then((res) => {
                this.fullscreenLoading = false;
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                    if (res.data.data) {
                        //清空回补时间
                        this.form.lineStopApplyDetails[index].amendTime = '';
                        this.Toast(resp.data);
                    }
                } else {
                    this.$message.error(res.data.msg);
                }
            });
            // alert(index)
        },
        delListItem(index) {
            this.form.lineStopApplyDetails.splice(index, 1)
        },

        changeMainFile(file) {
            let isLt5M = file.file.size / 1024 / 1024 < 20;
            if (!isLt5M) {
                this.$message.error('上传文件大小不能超过 20MB');
                this.$refs.createProject.clearFiles(); // 清除前端显示的文件列表
                return;
            }
            let formData = new FormData();
            formData.append('file', file.file);
            formData.append('fileName', file.file.name);
            this.fullscreenLoading = true;
            this.api.postImage(`/${serverConfig.msCommonAdminCloudService}/obs/upload-file-include-filename`, formData).then((res) => {
                this.fullscreenLoading = false;
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                    this.form.attaches.push({
                        name: file.file.name,
                        url: res.data.data.data,
                    });
                    console.log(this.form.attaches)
                    this.$message({
                        message: '上传成功',
                        type: 'success',
                    });
                }
            }).catch(() => {
                this.$message('上传失败！');
            });

        },
        handleMainRemove(file) {
            let attaches = this.form.attaches;
            attaches.forEach((item, index) => {
                if (item.url == file.url) {
                    attaches.splice(index, 1)
                }
            })
            this.form.attaches = attaches;
            console.log(file);
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        checkForm() {
            if (!this.form.lineStopRuleGuid) {
                this.$message.error('停线原因不能为空')
                return false;
            }
            if (!this.form.isFirstApply) {
                this.$message.error('是否为本核算月非公司统一活动的首次申请不能为空')
                return false;
            }
            if (!this.form.stopReasonDefinite) {
                this.$message.error('具体原因不能为空')
                return false;
            }
            try {
                this.form.lineStopApplyDetails.forEach(item => {
                    if (!item.stopTime || !item.amendTime) {
                        throw new Error('停线时间或者回补时间不能为空')
                    }
                })
            } catch (e) {
                this.$message.error(e.message);
                return false;
            }


            return true;
        },
        saveReq() {
            if (!this.checkForm()) return;
            let reqUrl = `/${serverConfig.msSalesPerformService}/line-stop-apply/update`;
            let req = JSON.parse(JSON.stringify(this.form));
            req.isApprove = 'N';
            if (req.attaches && req.attaches.length) {
                let attaches = [];
                req.attaches.forEach(itme => {
                    attaches.push({
                        fileName: itme.name,
                        path: itme.url
                    })
                })
                req.attaches = attaches;
            }
            if (req.lineStopApplyStaffList && req.lineStopApplyStaffList.length) {
                let staffList = this.staffList;
                let lineStopApplyStaffList = [];
                req.lineStopApplyStaffList.forEach(item => {
                    staffList.forEach(el => {
                        if (item == el.guid) {
                            lineStopApplyStaffList.push({
                                staffGuid: el.guid,
                                staffName: el.staffName
                            })
                        }
                    })
                })
                req.lineStopApplyStaffList = lineStopApplyStaffList;
            }
            this.fullscreenLoading = true;
            this.api.put(reqUrl, req).then((res) => {
                this.fullscreenLoading = false;
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                    this.$message({
                        message: '修改成功',
                        type: 'success',
                    });
                    this.$router.go(-1);
                } else {
                    this.$message.error(res.data.msg);
                }
            });
        }
    }
};
</script> 